import { useGetUserAgentsConfig } from '@/api/generated';

export const useUserAgents = () => {
  const response = useGetUserAgentsConfig({
    query: { queryKey: ['userAgentsConfig'] }
  });
  return response;
};
